export const environment = {
  production: true,
  clientRoot:`${window.location.origin}`,
  apiRoot: 'https://v2identity.raksainfo.info/api/',
    //  apiRoot: 'https://v2identity.raksainfo.info/api/',
  // apiRoot: 'https://localhost:44347/api/',
  stsAuthority: 'https://identity.raksainfo.info',
  // OpenIddict AuthServer that hosts the self-service account pages (/account/manage/*,
  // /account/confirmprofile).
  authServerRoot: 'https://identity.raksainfo.info',
  clientId:"raksaInfo-v4-client",
  analyticsEnabled: true,
  pushNotificationsEnabled: false,
  vapidPublicKey: '',
  googleApiKey: 'AIzaSyAPQnAVT-GKhkEDvZD5V2D-hXL9kjlG4jI',
  googleCseId: '45c798e97e6cc24f5',
  // Build metadata (optional). Populate via CI for better error diagnostics.
  appVersion: '4.2026.45+253.53d31608',
  buildSha: '53d31608d9a7595106147542a8ac78a69affbaae',
  buildTime: '2026-11-04T15:51:55.254Z',
  // Optional human name of the current major release (from release.json via set-build-info.mjs).
  // Empty = no codename is shown anywhere.
  codename: 'Cornerstone'
};
